let reqId = 0;
let iiWindow;
let eventHandler;
const INTERRUPT_CHECK_INTERVAL = 500;
function cleanUp() {
    if (eventHandler !== undefined) {
        window.removeEventListener("message", eventHandler);
    }
    eventHandler = undefined;
    iiWindow?.close();
    iiWindow = undefined;
}
function getEventHandler(id, principal, issuerOrigin, issuerCanisterId, credentialType, credentialArguments, derivationOrigin, url, onSuccess, _onError) {
    return (ev) => {
        console.debug("VC: received message on window: ", ev);
        if (ev.origin === url.origin) {
            console.debug("VC: message from correct origin received", ev.data);
            if ("method" in ev.data) {
                if (ev.data.method === "vc-flow-ready") {
                    const msg = {
                        id,
                        jsonrpc: "2.0",
                        method: "request_credential",
                        params: {
                            issuer: {
                                origin: issuerOrigin,
                                canisterId: issuerCanisterId,
                            },
                            credentialSubject: principal,
                            credentialSpec: {
                                credentialType,
                                arguments: credentialArguments,
                            },
                            derivationOrigin,
                        },
                    };
                    console.debug("VC: sending request_credential msg: ", msg);
                    iiWindow?.postMessage(msg, url.origin);
                }
            }
            if ("result" in ev.data && "verifiablePresentation" in ev.data.result) {
                if (ev.data.id === id) {
                    console.debug("VC: verification result received", ev.data.result.verifiablePresentation);
                    onSuccess(ev.data.result.verifiablePresentation);
                }
                else {
                    console.warn(`VC: WARNING: received a verified credential correlated with a different request - ignoring`);
                }
            }
        }
        else {
            console.warn(`VC: WARNING: expected origin '${url.origin}', got '${ev.origin}' (ignoring)`);
        }
    };
}
function onSuccess(resolve) {
    return (result) => {
        cleanUp();
        resolve(result);
    };
}
function onError(reject) {
    return (err) => {
        cleanUp();
        reject(err);
    };
}
function checkInterruption(reject) {
    if (iiWindow) {
        if (iiWindow.closed) {
            reject("II reason was closed");
            cleanUp();
        }
        else {
            window.setTimeout(() => checkInterruption(reject), INTERRUPT_CHECK_INTERVAL);
        }
    }
}
export function verifyCredential(iiUrl, principal, issuerOrigin, issuerCanisterId, credentialType, credentialArguments, derivationOrigin) {
    return new Promise((resolve, reject) => {
        cleanUp();
        console.debug("VC: about to verify credential", iiUrl, principal, issuerOrigin, issuerCanisterId, credentialType);
        reqId = reqId + 1;
        const url = new URL(iiUrl);
        url.pathname = "vc-flow/";
        console.debug("VC: opening II at url", url.toString());
        eventHandler = getEventHandler(reqId, principal, issuerOrigin, issuerCanisterId, credentialType, credentialArguments, derivationOrigin, url, onSuccess(resolve), onError(reject));
        window.addEventListener("message", eventHandler);
        iiWindow = window.open(url);
        checkInterruption(reject);
    });
}
